import { useState } from "react";
import { loginUser, signupUser } from "../services/authService";

export default function AuthPage() {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ fullName: "", email: "", password: "", role: "ROLE_RESTAURANT_OWNER" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      let data;
      if (mode === "login") {
        data = await loginUser(form.email, form.password);
      } else {
        data = await signupUser(form.fullName, form.email, form.password, form.role);
      }
      localStorage.setItem("token", data.jwt);
      localStorage.setItem("role", data.role);
      window.location.href = "/dashboard";
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center relative overflow-hidden">
      <div className="absolute top-[-80px] left-[-80px] w-[340px] h-[340px] rounded-full bg-orange-500 opacity-10 blur-3xl pointer-events-none" />
      <div className="absolute bottom-[-60px] right-[-60px] w-[280px] h-[280px] rounded-full bg-red-600 opacity-10 blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full max-w-md px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="text-4xl">🍽️</span>
            <h1 className="text-4xl font-black text-white tracking-tight">
              Sav<span className="text-orange-500">ora</span>
            </h1>
          </div>
          <p className="text-zinc-500 text-sm tracking-widest uppercase">
            {mode === "login" ? "Owner Dashboard" : "Create your account"}
          </p>
        </div>

        <div className="bg-[#1a1a1a] border border-zinc-800 rounded-2xl p-8 shadow-2xl">
          <div className="flex bg-zinc-900 rounded-xl p-1 mb-8">
            <button
              onClick={() => { setMode("login"); setError(""); }}
              className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${
                mode === "login" ? "bg-orange-500 text-white shadow" : "text-zinc-500 hover:text-zinc-300"
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => { setMode("signup"); setError(""); }}
              className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${
                mode === "signup" ? "bg-orange-500 text-white shadow" : "text-zinc-500 hover:text-zinc-300"
              }`}
            >
              Sign Up
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === "signup" && (
              <div>
                <label className="text-xs text-zinc-400 uppercase tracking-wider mb-1 block">Full Name</label>
                <input type="text" name="fullName" value={form.fullName} onChange={handleChange}
                  placeholder="Rahul Sharma" required
                  className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-xl px-4 py-3 text-sm placeholder-zinc-600 focus:outline-none focus:border-orange-500 transition-colors" />
              </div>
            )}

            <div>
              <label className="text-xs text-zinc-400 uppercase tracking-wider mb-1 block">Email</label>
              <input type="email" name="email" value={form.email} onChange={handleChange}
                placeholder="owner@restaurant.com" required
                className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-xl px-4 py-3 text-sm placeholder-zinc-600 focus:outline-none focus:border-orange-500 transition-colors" />
            </div>

            <div>
              <label className="text-xs text-zinc-400 uppercase tracking-wider mb-1 block">Password</label>
              <input type="password" name="password" value={form.password} onChange={handleChange}
                placeholder="Min 6 characters" required minLength={6}
                className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-xl px-4 py-3 text-sm placeholder-zinc-600 focus:outline-none focus:border-orange-500 transition-colors" />
            </div>

            {mode === "signup" && (
              <div>
                <label className="text-xs text-zinc-400 uppercase tracking-wider mb-1 block">Role</label>
                <select name="role" value={form.role} onChange={handleChange}
                  className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-orange-500 transition-colors">
                  <option value="ROLE_RESTAURANT_OWNER">Restaurant Owner</option>
                  <option value="ROLE_ADMIN">Admin</option>
                </select>
              </div>
            )}

            {error && (
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl px-4 py-3">
                <p className="text-red-400 text-sm">⚠️ {error}</p>
              </div>
            )}

            <button type="submit" disabled={loading}
              className="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-orange-500/50 text-white font-bold py-3 rounded-xl transition-all duration-200 text-sm tracking-wide mt-2">
              {loading ? "Please wait..." : mode === "login" ? "Sign In →" : "Create Account →"}
            </button>
          </form>

          <p className="text-center text-zinc-600 text-xs mt-6">
            {mode === "login" ? "New here? " : "Already have an account? "}
            <button onClick={() => { setMode(mode === "login" ? "signup" : "login"); setError(""); }}
              className="text-orange-400 hover:text-orange-300 font-medium transition-colors">
              {mode === "login" ? "Create account" : "Sign in"}
            </button>
          </p>
        </div>

        <p className="text-center text-zinc-700 text-xs mt-6">© 2024 Savora · Admin Panel</p>
      </div>
    </div>
  );
}